module.exports = __webpack_public_path__ + "img/ic_manager_reply_rate.2c1a4de6.png";